export const CATEGORIES = {
	ACTIVE: 'Saved search filter/active',
	ADD: 'Add saved search',
	DEFAULT: 'Saved searches',
	DELETE: 'Delete saved search',
	LIST: 'Saved search list',
	MANAGE: 'Manage saved search',
	MODAL: 'Saved filters modal',
	PILL: 'Saved search pill',
};

export const ACTIONS = {
	clickEditButton: 'User selected edit saved search',
	clickEmptySavedSearch: 'Empty saved search pill clicked',
	closeButton: 'X button clicked on saved search list',
	createSavedSearchButton: 'Create saved search button selected',
	disableSavedSearch: 'User disabled saved search',
	hoverActiveSavedSearch: 'User hovered over saved search filtered/active pill',
	hoverActiveSavedSearchButton: 'User hovered over saved search button',
	hoverDisabledSavedSearchButton: 'User hovered over disabled saved search pill',
	hoverEditButton: 'User hovered over edit saved search',
	hoverEmptySavedSearch: 'User hovered over empty saved search pill',
	hoverSavedSearchItem: 'User hovered over saved search option',
	hoverShowVehiclesButton: 'User hovered over show X vehicles',
};
